/** Тексты, которые бот пишет в каналах Discord. */

import type { ReactNode } from 'react';

import { MessageEditor } from '../../components/message-editor.tsx';
import { Section, type SettingsTabProps } from './shared.tsx';

export function MessagesTab({ draft, update }: SettingsTabProps): ReactNode {
  return (
    <Section
      title="Тексты в Discord"
      description="Панели, приветствия и объявления в каналах. Меняются на лету: панели обновляются при следующей разметке сервера, остальное — сразу."
    >
      <MessageEditor
        value={draft.messages}
        onChange={(next) => {
          update('messages', next);
        }}
      />
    </Section>
  );
}
